const Footer = () => {
  return <div className="w-full h-40 bg-slate-200"></div>;
};

export default Footer;
